// matches /locations/<public_id> where public_id starts with "loca_"
const LOCATION_PATTERN = /^\/locations\/(loca_[^/]+)/;

export function extractLocationId(url: string): string | null {
  const pathname = new URL(url, window.location.origin).pathname;
  const match = pathname.match(LOCATION_PATTERN);
  return match ? match[1]! : null;
}

export function currentLocationId(): string | null {
  return extractLocationId(window.location.pathname);
}

export function isCrossLocationNavigation(destinationUrl: string): {
  from: string;
  to: string;
} | null {
  const from = currentLocationId();
  const to = extractLocationId(destinationUrl);
  if (from && to && from !== to) {
    return { from, to };
  }
  return null;
}
